import { ApolloClient, InMemoryCache } from '@apollo/client'
import additiveLink from './compose.link'

const apolloClient = new ApolloClient({
  link: additiveLink,
  cache: new InMemoryCache(),
})

export default apolloClient
